import { useEffect } from 'react';

import { APP_NAME } from './brand';

/**
 * The title of the browser's tab for this page: "Notes on the staff — EasyMusic". The
 * server writes the same for the page as it serves it (docs/seo.md); this keeps it right
 * as the visitor moves about. Until the page knows its title (null), the tab keeps what it
 * has; leaving the page gives the tab back the name of the product.
 */
export function usePageTitle(title: string | null | undefined): void {
  useEffect(() => {
    if (!title) return;
    document.title = `${title} — ${APP_NAME}`;
    return () => {
      document.title = APP_NAME;
    };
  }, [title]);
}
